import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { userSelector } from 'selectors/user/userSelector';
import { isAnonymousSelector } from 'selectors/auth/isAnonymousSelector';
import Actions from 'actions/Actions';
import userActions from 'actions/UserActions';
import framework from 'utils/framework';

const { wrapHOC } = framework;

const fields = createStructuredSelector({
    user: userSelector,
    isAnonymous: isAnonymousSelector
});

const functions = {
    showSignInModal: Actions.showSignInModal,
    showRegisterModal: Actions.showRegisterModal,
    showForgotPasswordModal: Actions.showForgotPasswordModal,
    submitSMSForm: userActions.submitSMSOptInForm,
    submitSignInForm: userActions.signIn
};

const withSMSOptInProps = wrapHOC(connect(fields, functions));

export {
    withSMSOptInProps, fields, functions
};
